import moment from 'moment-timezone';

function scheduledTimeInEst(scheduledDateTime) {
  return `${moment.utc(scheduledDateTime).tz("America/New_York").format("DD MMM YYYY - HH:mm a")} EST`;
}

export default scheduledTimeInEst;